import type { ApiResponse } from '@creator/sdk/creator-sdk';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';
import type { Comment } from '@src/store/contentEntities/model';
import { setComment } from './comments';

export interface DeleteCommentApiRequestPayload {
    userId?: string;
    commentId: string;
    tokenName: string;
    hidden: boolean;
    reason?: string;
    reasonText?: string;
}

export const deleteComment = async (payload: DeleteCommentApiRequestPayload) => {
    const { commentId } = payload;
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Comment>>(
        '/comment/delete',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false,
    );

    const comment = { ...data.payload, id: commentId };
    setComment(comment);
    return comment;
};
